// CLIFLoader.jsx
import React from "react";
import "./ClifLoader.css";

const CLIFLoader = () => {
  return (
    <div className="clif-loader">
      <div className="circle1">C</div>
      <div className="circle1">L</div>
      <div className="circle1">I</div>
      <div className="circle1">F</div>
    </div>
  );
};

export default CLIFLoader;
